export const FormActionTypes = {
  onChange: 'ON_CHANGE',
  onBlur: 'ON_BLUR',
  onFocus: 'ON_FOCUS',
  onInit: 'ON_INIT'
};